import Vue from 'vue';
import Router from 'vue-router';
import Login from '../components/Login.vue';
import UserActivity from '../components/UserActivity.vue';
import Admin from '../components/Admin.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/useractivity',
      name: 'User Activity',
      component: UserActivity,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const { loggedIn } = localStorage;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !loggedIn) next('login');
  else if (!requiresAuth && loggedIn) next('useractivity');
  else next();
});

export default router;
